const getDefaultState = () => {
  return {
    radioflag1: null,
    radioflag2: null,
    comment1: {
      show: false,
      text: ""
    },
    comment2: {
      show: false,
      text: ""
    },
    comment3: {
      show: false,
      text: ""
    },
    all: null,
    allPayload: null
  };
};

export default {
  state: getDefaultState(),
  getters: {
    getRadio1(state) {
      return state.radioflag1;
    },
    getRadio2(state) {
      return state.radioflag2;
    },
    getComment1(state) {
      return state.comment1;
    },
    getComment2(state) {
      return state.comment2;
    },
    getComment3(state) {
      return state.comment3;
    },
    getAllComment(state) {
      return [state.comment1, state.comment2, state.comment3];
    },
    getAll(state) {
      return state.all;
    },
    getAllPayLoad(state) {
      return state.allPayload;
    }
  },
  mutations: {
    /**
     * 初期化
     */
    init(state) {
      Object.assign(state, getDefaultState());
    },
    setRadio1(state, list) {
      state.radioflag1 = list;
    },
    setRadio2(state, list) {
      state.radioflag2 = list;
    },
    setCommentStatus(state, item) {
      state[`comment${item.type}`].show = item.show;
    },
    setCommentText(state, item) {
      state[`comment${item.type}`].text = item.text;
    },
    setAll(state, data) {
      state.all = data;
    },
    setAllPayload(state, data) {
      state.allPayload = data;
    }
  }
};
